import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import { API_BASE_URL } from '../../config/api';
import '../../styles/ModuloEditor.css';

const ModuloEditor = () => {
  const { cursoId, moduloId } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  useEffect(() => {
    if (moduloId) {
      const fetchModulo = async () => {
        try {
          const token = localStorage.getItem('token');
          const response = await axios.get(`${API_BASE_URL}/cursos/${cursoId}/modulos/${moduloId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            }
          });
          setTitle(response.data.title);
          setContent(response.data.content);
        } catch (error) {

        }
      };

      fetchModulo();
    }
  }, [moduloId]);

  const handleSave = async () => {
    if (!title.trim() || !content.trim()) return;

    const data = {
      title,
      content,
    };

    try {
      const token = localStorage.getItem('token');
      if (moduloId) {
        // Editar módulo existente
        await axios.put(`${API_BASE_URL}/cursos/${cursoId}/modulos/${moduloId}`, data, {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        });
        alert('Módulo atualizado com sucesso!');
      } else {
        // Criar novo módulo
        await axios.post(`${API_BASE_URL}/cursos/${cursoId}/modulos`, data, {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        });
        alert('Módulo criado com sucesso!');
      }
      navigate(`/curso/${cursoId}`); // Navegar de volta para a página do curso ou onde desejar
    } catch (error) {

      alert('Ocorreu um erro ao salvar o módulo.');
    }
  };

  return (
    <div className="modulo-editor">
      <h1>{moduloId ? 'Editar Módulo' : 'Novo Módulo'}</h1>
      <div>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Título do módulo"
          label="Título do módulo"
        />
      </div>
      <div>
        <ReactQuill
          value={content}
          onChange={setContent}
          placeholder="Conteúdo do módulo"
          modules={{
            toolbar: [
              [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [{'script': 'sub'}, {'script': 'super'}],
              [{'color': []}, {'background': []}],
              [{'align': []}],
              ['link', 'image', 'video'],
              ['clean'],
              ['code-block'],
            ]
          }}
          formats={[
            'header', 'font',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet',
            'link', 'image', 'video',
            'code-block', 'script',
            'color', 'background',
            'align',
          ]}
        />
      </div>
      <button onClick={handleSave}>
        {moduloId ? 'Salvar Alterações' : 'Criar Módulo'}
      </button>
    </div>
  );
};

export default ModuloEditor;
